import { LandingPage as NewLandingPage } from "@components/Home/NewLandingPage";
import { NextPage } from "next";

import { FeedItemResponse } from "@every.org/common/src/codecs/entities";

type LandingPageProps = {
  feedItems?: FeedItemResponse[];
};

export const LandingPage: NextPage<LandingPageProps> = (props) => {
  return <NewLandingPage {...props} />;
};
